import { getCurrentFileStateParamsType } from '@/common/queries/getCurrentFileState/getCurrentFileState.type';
import { getCurrentFileStateQueryFunction } from '@/common/queries/getCurrentFileState/getCurrentFileStateQueryFunction';
import { queryOptions } from '@tanstack/react-query';

const getCurrentFileStateQueryOption = (
  params: getCurrentFileStateParamsType,
) => {
  return queryOptions({
    queryKey: ['getCurrentFileState', params],
    queryFn: () => getCurrentFileStateQueryFunction(params),
  });
};

export default getCurrentFileStateQueryOption;
